import { defineComponent, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { MsgBox } from "~/components/MsgBox";
import MyPageNumberInput from "~/components/MyPageNumberInput.vue";
import { Log } from "~/extensions/utils";
import { HanyoKb, PageID } from "~/extensions/utils/DefineTypes";
import { HanyoHelper } from "~/extensions/utils/HanyoHelper";
import { PagingListHelper } from "~/extensions/utils/PagingHelper";
import { store } from "~/store/admin/NyukyoshaStore";
import Loading from 'quasar/src/plugins/loading/Loading.js';
import { GetHanyoParam } from "~/api/Common/Commands";
import BreadcrumbList from "~/components/BreadcrumbList.vue";
import MypageBadge from "~/components/MypageBadge.vue";
import MyPageTable from "~/components/MyPageTable.vue";
import { commonStore } from "~/store/CommonStore";
const log = Log.create("NyukyoshaList");
// 入居状況区分
const NyukyoKbn = HanyoKb.NyukyoKb;
export default defineComponent({
    components: {
        MyPageTable,
        MypageBadge,
        MyPageNumberInput,
        BreadcrumbList
    },
    name: "nyukyoshaList",
    beforeRouteEnter(to, from, next) {
        const fromScreen = from.name;
        const relatedScreens = ["nyukyosha-detail"];
        if (!relatedScreens.includes(fromScreen)) {
            store.clear();
        }
        next();
    },
    async setup() {
        const pageName = commonStore.pageName(PageID.nyukyoshaList);
        const top = PageID.top;
        const nyukyoshaList = PageID.nyukyoshaList;
        const router = useRouter();
        // 入居状況プルダウン
        let statusList = ref([]);
        const pagingListHelper = new PagingListHelper({ mode: "store", store }, log);
        // テーブルカラム
        const columns = [
            { name: "editIcon", align: "left", field: "editIcon", sortable: false },
            { name: "UserCd", label: "契約者コード", align: "right", field: "UserCd", sortable: true },
            { name: "UserName", label: "契約者名", align: "left", field: "UserName", sortable: true, headerStyle: "width: 300px; max-width: 300px" },
            { name: "NyukyokeiyakuNo", label: "入居契約No.", align: "right", field: "NyukyokeiyakuNo", sortable: true },
            { name: "NyukyoshaName", label: "入居者名", align: "left", field: "NyukyoshaName", sortable: true, headerStyle: "width: 300px; max-width: 300px" },
            { name: "BukenCd", label: "物件コード", align: "right", field: "BukenCd", sortable: true },
            { name: "BukenName", label: "物件名", align: "left", field: "BukenName", sortable: true, headerStyle: "width: 300px; max-width: 300px" },
            { name: "RoomNo", label: "号室", align: "left", field: "RoomNo", sortable: true },
            { name: "TaikyoStatus", label: "入居状況", align: "center", field: "TaikyoStatus", sortable: true }
        ];
        const initView = async () => {
            try {
                await getHanyo();
            }
            catch (ex) {
                await MsgBox.error(ex.data.errorMessage);
                log.error("find", ex);
            }
        };
        //ページング処理
        const onRequest = async (requestData) => {
            Loading.show();
            await pagingListHelper.paging(requestData);
            Loading.hide();
        };
        const onChange = () => {
            store.condition.isSearch = false;
        };
        //検索ボタン押下の処理
        const onSearch = async () => {
            store.condition.isSearch = true;
            Loading.show();
            await pagingListHelper.search();
            Loading.hide();
        };
        //行押下時の処理
        const onClick = (nyukyokeiyakuNo) => {
            router.push({ name: "nyukyosha-detail", query: { nyukyokeiyakuNo: nyukyokeiyakuNo } });
        };
        const getHanyo = async () => {
            let gethanyoParam = [new GetHanyoParam(HanyoKb.NyukyoKb)];
            let hanyoList = await HanyoHelper.getHanyoList(gethanyoParam);
            statusList.value = hanyoList.GetByHanyoKb(HanyoKb.NyukyoKb).filter(item => [0, 1, 6].includes(item.value));
        };
        initView();
        return {
            ...toRefs(store),
            columns,
            expansionState: ref(true),
            statusList,
            NyukyoKbn,
            pageName,
            top,
            nyukyoshaList,
            onSearch,
            onChange,
            onRequest,
            onClick
        };
    }
});
